import api from './api';

const authService = {
  setCurrentUser: (user) => {
    if (!user) {
      localStorage.removeItem('user');
      return null;
    }

    localStorage.setItem('user', JSON.stringify(user));
    return user;
  },

  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    if (response.data.token) {
      api.invalidateCache();
      localStorage.setItem('token', response.data.token);
      authService.setCurrentUser(response.data.user);
    }
    return response.data;
  },

  logout: () => {
    api.invalidateCache();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  validateToken: async () => {
    const token = localStorage.getItem('token');
    if (!token) return { valid: false, error: 'No token found' };
    
    try {
      const response = await api.get('/auth/verify');
      return {
        valid: Boolean(response.data?.valid),
        user: response.data?.user
      };
    } catch (error) {
      return { 
        valid: false, 
        error: error.response?.data?.error || error.message 
      };
    }
  },

  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token, new_password) => {
    const response = await api.post('/auth/reset-password', { token, new_password });
    return response.data;
  }
};

export default authService;
